// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"573":"741698fc","787":"abea0d16","960":"31ecf616"}[chunkId] + ".chunk.js";
};